angular.module('app').component('adminCheckbox', {
    templateUrl: 'events/components/checkbox.html',
    bindings: {
        ariaLabel: '@?checkboxAriaLabel',
        disabled: '<?',
        label: '@',
        model: '='
    }
});
